import React, { useContext, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { RolesContext } from "../context/User";
import axios from "axios";

const PopupWithSelect = () => {
  const [selectedOption, setSelectedOption] = useState("");
  const [stateroles, dispatchroles] = useContext(RolesContext);
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.get(
        `/adminPermissions/change_cust_id/${selectedOption.CUSTNAME}~${selectedOption.CUSTDES}`,
        // `/adminPermissions/change_cust_id/${selectedOption.CUSTNAME}`,
        {
          withCredentials: true,
        }
      );
      setOpen(false);
    } catch (error) {
      if (error.response.status == 403) {
        navigate("/");
      }
    }
    dispatchroles({
      type: "USER_UPDATE",
      payload: {
        value: selectedOption.CUSTNAME,
        title: "userId",
      },
    });
    navigate(`/${"portal"}`);
  };

  return (
    <div>
      <Dialog
        open={stateroles.customers.length == 1 ? false : open}
        fullWidth
        maxWidth="xs"
        sx={{
          "& .MuiDialog-container": {
            alignItems: "flex-start",
          },
        }}
        PaperProps={{
          sx: {
            mt: { xs: 2, sm: 4 },
            maxHeight: "80vh",
          },
        }}
      >
        <DialogTitle style={{ textAlign: "right" }}>
          נא לבחר מספר לקוח
        </DialogTitle>
        <DialogContent>
          <FormControl fullWidth variant="standard">
            <InputLabel id="select-option-label">מספר לקוח</InputLabel>
            <Select
              labelId="select-option-label"
              id="select-option"
              value={selectedOption}
              onChange={handleOptionChange}
              sx={{ width: "100%", textAlign: "left" }}
            >
              {stateroles.customers.map((component, index) => (
                <MenuItem key={index} value={component}>
                  {component.CUSTDES}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmit} color="primary">
            שלח
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PopupWithSelect;
